<template>
  <div>
    <v-card>
      <v-card-title>总部请假申请单</v-card-title>
      <v-card-text>
        <v-row>
          <v-col md="6">
            <!-- :errMsg="$errors('reqParams', 'source_table', requiredRule)" -->
            <mrc_ess_prompt
              :label="$t('公司')"
              :disabled="true"
              obj="unit"
              v-model="params.company_uuid"
            >
            </mrc_ess_prompt>
          </v-col>
          <v-col md="6">
            <mrc_ess_datePicker
              label="填单时间"
              :disabled="true"
              v-model="params.fill_in_time"
              placeholder="填单时间"
            ></mrc_ess_datePicker>
          </v-col>
          <v-col md="4">
            <mrc_ess_prompt
              :label="$t('部门')"
              :disabled="true"
              obj="unit"
              v-model="params.department_uuid"
            >
            </mrc_ess_prompt>
          </v-col>
          <v-col md="4">
            <mrc_ess_prompt
              :label="$t('姓名')"
              :disabled="true"
              view_fields="show_name"
              value_field="uuid"
              :select_arr="nameArr"
              v-model="params.staff_uuid"
            >
            </mrc_ess_prompt>
          </v-col>
          <v-col md="4">
            <mrc_ess_dictName
              v-model="params.Leave_type"
              :disabled="false"
              :label="$t('请假类型')"
              :rules="false"
              :placeholder="$t('请假类型')"
              dict_name="Leave_type"
              :errMsg="$errors('params', 'Leave_type', requiredRule)"
              chips
            ></mrc_ess_dictName>
          </v-col>
          <v-col md="4">
            <mrc_ess_datePicker
              label="开始时间"
              :disabled="false"
              v-model="params.start_time"
              placeholder="开始时间"
              :errMsg="
                $errors('params', 'start_time', [
                  { rule: 'beforeData', msg: '不能超过结束时间' },
                ])
              "
              @blur="$v.params.start_time.$touch()"
            ></mrc_ess_datePicker>
          </v-col>
          <v-col md="4">
            <mrc_ess_datePicker
              label="结束时间"
              :disabled="false"
              :errMsg="
                $errors(
                  'params',
                  'end_time',
                  requiredRule.concat([
                    { rule: 'afterData', msg: '不能小于开始时间' },
                  ])
                )
              "
              @blur="$v.params.end_time.$touch()"
              v-model="params.end_time"
              placeholder="结束时间"
            ></mrc_ess_datePicker>
          </v-col>
          <v-col md="4">
            <mrc_ess_input
              placeholder="共（天）"
              label="共（天）"
              v-model="params.day"
              :error-messages="$errors('params', 'day', requiredRule)"
            ></mrc_ess_input>
          </v-col>
          <v-col md="12">
            <mrc_ess_input
              textarea
              placeholder="请假原因"
              label="请假原因"
              v-model="params.cause"
            ></mrc_ess_input>
          </v-col>
          <v-col md="12">
            <mrc_ess_input
              placeholder="附件"
              label="附件"
              v-model="params.accessory_uuid"
            ></mrc_ess_input>
          </v-col>
          <!-- <v-col md="12">
            <mrc_ess_input
              textarea
              placeholder="部门经理意见"
              label="部门经理意见"
            ></mrc_ess_input>
          </v-col>
          <v-col md="12">
            <mrc_ess_input
              textarea
              placeholder="人事部意见"
              label="人事部意见"
            ></mrc_ess_input>
          </v-col> -->
        </v-row>
      </v-card-text>
      <mrc_ess_submitBtn
        :loading="loading"
        @success="add"
        @cancel="cancel"
      ></mrc_ess_submitBtn>
    </v-card>
  </div>
</template>

<script>
import { getTestLeaveApplicationAdd } from "@/service/api/data-access-strategy";
import { getBusinessList } from "@/service/api/prompt";
import { required } from "vuelidate/lib/validators";
export default {
  props: {},
  validations: {
    params: {
      day: {
        required,
      },
      Leave_type: {
        required,
      },
      start_time: {
        required,
        beforeData(value) {
          if (!this.params.start_time) return false;
          if (!this.params.end_time) return true;
          const prevData = new Date(value).valueOf();
          const nextData = new Date(this.params.end_time).valueOf();
          return prevData < nextData;
        },
      },
      end_time: {
        required,
        afterData(value) {
          const prevData = new Date(this.params.start_time).valueOf();
          const nextData = new Date(value).valueOf();
          return prevData < nextData;
        },
      },
    },
  },
  data() {
    return {
      loading: false,
      nameArr: [],
      params: {
        company_uuid: this.$store.state.userData.org_level_uuid,
        department_uuid: this.$store.state.userData.dept_uuid,
        staff_uuid: "",
        fill_in_time: new Date().valueOf(),
        start_time: null,
        end_time: null,
        day: "",
        cause: "",
        Leave_type: "",
        accessory_uuid: "",
      },
    };
  },
  async created() {
    try {
      const res = await getBusinessList({
        prompt_name: "userId_show_name",
        user_id: this.$store.state.userData.user_id,
      });
      if (res.code == 200) {
        this.nameArr = res.data;
        this.params.staff_uuid = this.nameArr[0].uuid;
      } else {
        this.$Message({ text: "员工姓名未获取到，请刷新页面重新获取" });
      }
    } catch (err) {
      this.$Message({ text: "员工姓名未获取到，请刷新页面重新获取" });
    }
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    async add() {
      this.$v.params.$touch();
      if (this.$v.params.$error) return;
      this.loading = true;
      try {
        // this.params.start_time = new Date(this.params.start_time).valueOf()
        // this.params.end_time = new Date(this.params.end_time).valueOf()
        this.params.start_time = this.$moment(this.params.start_time);
        this.params.end_time = this.$moment(this.params.end_time);
        this.params.fill_in_time = this.$moment(this.params.fill_in_time);
        const res = await getTestLeaveApplicationAdd(this.params);
        if (res.code == 200) {
          this.$Message({ text: "成功", color: "rgba(0,0,0,0.78)" });
          this.$router.go(-1);
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    cancel() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
      })
        .then(() => {
          this.$router.go(-1);
        })
        .catch(() => {
          // console.log('点了取消')
        });
    },
  },
};
</script>

<style scoped></style>
